/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {SVG_CONFIG as ɵa,SVG_ICONS as ɵc,SVG_ICONS_CONFIG as ɵb} from './lib/types';